import { render, staticRenderFns } from "./SharedUsersItem.vue?vue&type=template&id=98b5cc28&"
import script from "./SharedUsersItem.vue?vue&type=script&lang=js&"
export * from "./SharedUsersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports